import type { PusherMethod } from '../../consts/pusher/methods';
import { isPusherMethod, PUSHER_METHOD_TYPES } from '../../consts/pusher/methods';

function isObjectRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

function parseInitPayload(payload: unknown): { authValue: string } | undefined {
  if (!isObjectRecord(payload)) return undefined;
  const { authValue } = payload;
  if (typeof authValue !== 'string') return undefined;
  return { authValue };
}

function parseSubscribePayload(payload: unknown): { channel: string } | undefined {
  if (!isObjectRecord(payload)) return undefined;
  const { channel } = payload;
  if (typeof channel !== 'string' || !channel) return undefined;
  return { channel };
}

function parseUnsubscribePayload(payload: unknown): { channel: string } | undefined {
  if (!isObjectRecord(payload)) return undefined;
  const { channel } = payload;
  if (typeof channel !== 'string' || !channel) return undefined;
  return { channel };
}

export const toPusherMethod = (
  eventType?: string,
  eventPayload?: unknown,
): PusherMethod | undefined => {
  if (!isPusherMethod(eventType)) return undefined;

  switch (eventType) {
    case PUSHER_METHOD_TYPES.init: {
      const parsed = parseInitPayload(eventPayload);
      return parsed ? { eventType, eventPayload: parsed } : undefined;
    }
    case PUSHER_METHOD_TYPES.subscribe: {
      const parsed = parseSubscribePayload(eventPayload);
      return parsed ? { eventType, eventPayload: parsed } : undefined;
    }
    case PUSHER_METHOD_TYPES.unsubscribe: {
      const parsed = parseUnsubscribePayload(eventPayload);
      return parsed ? { eventType, eventPayload: parsed } : undefined;
    }
    default:
      return undefined;
  }
};
